import React, { useEffect } from "react";
import HeroCarousel from "../components/carousel/HeroCarousel";
import { Link } from "react-router-dom";
import CardSlider from "../components/Slider/CardSlider";
import CardContainer from "../components/Card/CardContainer";
import Card from "../components/Card/Card";
import SafetySlider from "../components/Slider/SafetySlider";
import Page from "../layout/Page";
const slides = [
  {
    title: "Safety",
    description:
      "As a leading telematics solutions provider, we’re tackling one of the primary causes of accidents—driver distraction—by implementing advanced safety measures powered by AI, machine learning (ML), and the Internet of Things (IoT) to save lives and enhance road safety.",
    statsImage:
      "https://images.ctfassets.net/bx9krvy0u3sx/3J7WcpdS4aE0B0b7HP66eb/4f2e4eb1d0fcbf5c14942a09d9932cd7/US_Summit_Material_Stats.png?w=2000&h=774&fm=webp&q=80",
    mainImage:
      "https://images.pexels.com/photos/13404720/pexels-photo-13404720.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    linkText: "Find out about our products",
  },
  {
    title: "Efficiency",
    description:
      "FleetSense, our advanced fleet safety solution, leverages real-time communication between vehicles and their environment to elevate fleet monitoring and operational efficiency. By optimising fleet operations, FleetSense ultimately reduces the cost of ownership and maximises return on investment (ROI). As digital transformation gains momentum, companies that resist adopting new technologies will struggle to match the efficiency and competitive edge offered by telematics.",
    statsImage:
      "https://images.ctfassets.net/bx9krvy0u3sx/3J7WcpdS4aE0B0b7HP66eb/4f2e4eb1d0fcbf5c14942a09d9932cd7/US_Summit_Material_Stats.png?w=2000&h=774&fm=webp&q=80",
    mainImage:
      "https://images.pexels.com/photos/4824425/pexels-photo-4824425.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    linkText: "Know more",
  },
  {
    title: "Sustainability",
    description:
      "Fleet owners can track drivers with the lowest diesel consumption on specific routes and create daily high-score rankings, promoting efficient driving practices. Reducing idle times is also crucial, as they lead to significant fuel waste and unnecessary carbon emissions.",
    statsImage:
      "https://images.ctfassets.net/bx9krvy0u3sx/3J7WcpdS4aE0B0b7HP66eb/4f2e4eb1d0fcbf5c14942a09d9932cd7/US_Summit_Material_Stats.png?w=2000&h=774&fm=webp&q=80",
    mainImage:
      "https://images.pexels.com/photos/11115607/pexels-photo-11115607.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    linkText: "Download Report",
  },
];
const About = () => {
  const heroSlides = [
    {
      bg: "images/hero/2.webp",
      // textImg: "images/hero/text1.webp",
      buttonText: "Learn More",
      buttonLink: "#",
    },
    {
      bg: "images/hero/3.webp",
      // textImg: "images/hero/text2.webp",
      buttonText: "Learn More",
      buttonLink: "#",
    },
    {
      bg: "images/hero/5.webp",
      // textImg: "images/hero/text3.webp",
      buttonText: "Learn More",
      buttonLink: "#",
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <Page
      title="About Shoora - Advanced Telematics Solutions"
      description="Discover how Shoora leverages AI, ML, and IoT to enhance road safety, operational efficiency, and sustainability in the commercial fleet industry."
      keywords="telematics, AI, IoT, fleet safety, road safety, logistics"
    >
      <div className="about-hero">
        <img src="images/about/bg3.webp" alt="" />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div className="col col-12 col-lg-6">
            <p className="fs-1 text-light mb-5"></p>
            <h1 className="text-accent about-hero-title mb-4">
              Discover how the Fleets works with Shoora
            </h1>
            <p className="fs-5 text-light mb-5">
              We help organisations of every size, in every industry, put AI to
              work for the commercial fleet industry
            </p>
            <div className="d-lg-flex">
              <button className="btn btn-outline-info rounded-5">
                <i class="fa-regular fa-circle-play"></i> Watch Video (2.33)
              </button>
              <Link className="ms-lg-3 mt-3 mt-lg-0 btn btn-link text-white text-decoration-none">
                <i class="fa-solid fa-circle-arrow-down"></i> Download Company
                Profile
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row row-cols-1 row-cols-lg-2 align-items-start mb-5">
          <div className="col">
            <h1 className="text-center fw-lighter mb-5 display-1 p-lg-5 mx-lg-5">
              About Shoora
            </h1>
          </div>
          <div className="col" style={{ fontSize: "12px" }}>
            <p>
              Shoora is pioneering groundbreaking technology and solutions to
              enhance operational efficiency and ensure road safety. As a
              Telematics Solutions Provider, we are addressing one of the
              leading causes of accidents—driving distraction—to save countless
              lives and provide advanced safety measures through cutting-edge
              technologies such as AI, machine learning (ML), and the Internet
              of Things (IoT).
            </p>
            <p>
              Our technology protects drivers during critical moments by
              detecting safety events with AI powered telematics and offering
              on-demand video retrieval. Our goal is to connect all stakeholders
              in the commercial fleet industry, from drivers to fleet operators,
              to enhance the quality of life for drivers and provide peace of
              mind for fleet managers.
            </p>
            <p>
              At Shoora, we utilise machine learning and artificial intelligence
              to build applications that enable predictive decision-making,
              in-vehicle intelligence, and object recognition. Our innovative
              technologies empower businesses to stay ahead in the competitive
              landscape by improving efficiency, safety, and overall
              performance.
            </p>
            <p>
              By integrating AI, ML, and IoT into our solutions, we are creating
              a safer and more efficient future for the transportation and
              logistics industry. Our commitment to innovation and excellence
              ensures that we continue to lead the way in developing
              technologies in emerging mobility mega pools that protect drivers,
              enhance operational efficiency, and drive digital transformation.
            </p>
          </div>
        </div>
      </div>
      <div className="my-5 container-fluid core-values">
        <h1
          className="text-center mb-5  p-lg-5 mx-lg-5"
          style={{ fontSize: "55px" }}
        >
          Values at Shoora
        </h1>
        <div className="row row-cols-1 row-cols-lg-2 align-items-center mb-5">
          <div className="col p-0">
            <img
              src="https://images.pexels.com/photos/2101140/pexels-photo-2101140.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              alt=""
              style={{
                height: "550px",
                width: "100%",
                objectFit: "cover",
                borderRadius: "0 20px 20pc 0",
              }}
            />
          </div>
          <div className="col">
            <h2 className="px-5 pt-5">VISION</h2>
            <p className="fs-4 p-5">
              To transform the transportation and logistics industry with
              state-of-the-art, software-defined digital mobility solutions that
              boost operational efficiency, elevate safety standards, and
              promote sustainability.
            </p>
          </div>
        </div>
        <div className="row row-cols-1 row-cols-lg-2 align-items-center mb-5 p-0">
          <div className="col align-items-center">
            <h2 className="px-5 pt-5">Mission</h2>
            <p className="fs-4  p-5">
              To spearhead the shift from hardware to software-defined vehicle
              architectures and V2X technologies, we develop cutting-edge
              solutions that integrate sensors, geospatial data, and cloud
              platforms. Our mission is to deliver real-time communication and
              data-driven insights, empowering fleets to optimise operations,
              cut costs, and enhance driver performance.
            </p>
          </div>
          <div className="col p-0">
            <img
              src="https://images.pexels.com/photos/3182750/pexels-photo-3182750.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              alt=""
              style={{
                height: "550px",
                width: "100%",
                objectFit: "cover",
                borderRadius: "20pc 0px 0px 20px",
              }}
            />
          </div>
        </div>
      </div>
      <div className="container-fluid core-values">
        <div className="row row-cols-1 row-cols-lg-2 align-items-center mt-5">
          <div className="col d-none d-lg-block p-0">
            <img
              src="https://images.pexels.com/photos/3182750/pexels-photo-3182750.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              alt=""
              style={{
                height: "700px",
                width: "80%",
                objectFit: "cover",
                borderRadius: "0 20px 20px 0",
              }}
            />
          </div>
          <div className="col px-5 px-lg-0">
            <h2 className=" py-3 ">Objectives</h2>
            <h2 className="ps-3 pe-5 fs-3 mb-3">
              Our objectives aren’t just words; they’re the bedrock of
              everything we do:
            </h2>
            <ul className="multicolor-list text-dark  ">
              <li>
                <b>Improve Safety and Sustainability:</b> Ensure safer roads and
                more efficient logistics operations through innovative
                technologies and data-driven decision-making.
              </li>
              <li>
                <b>Innovate and Develop:</b> Create advanced technologies that
                incorporate sensors and integrated circuits into road
                infrastructure and cloud platforms, shifting costs away from
                vehicles.
              </li>
              <li>
                <b>Enhance Fleet Management:</b> Offer comprehensive solutions
                that track vehicle locations, monitor driver performance,
                optimise routes, and reduce fuel consumption.
              </li>
              <li>
                <b>Drive Digital Transformation:</b> Leverage AI, IoT, and
                connectivity to transform vehicle telematics and fleet
                management, providing real-time data and insights to improve
                operational efficiency.
              </li>
              <li>
                {" "}
                <b>Foster Industry Leadership:</b> Establish Shoora as a leading
                provider of software-defined vehicle solutions, driving the
                adoption of V2X technologies and smart mobility.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="p-5">
        <div className="row justify-content-between ">
          <div className="col col-12 col-lg-4 mb-5 mb-lg-0">
            <div>
              <h6 className="text-accent">Quick Facts.</h6>
              <h2 className="fs-1 fw-bold mb-4">
                The Shoora Impact in a Changing World
              </h2>
              <p className=" fs-5">
                As fleet owners increasingly turn to technology to boost
                operational efficiency,{" "}
                <span className="text-accent">Shoora</span> is fast becoming the
                top choice for advanced fleet management and video telematics
                solutions.
              </p>
            </div>
          </div>
          <div className="col col-12 col-lg-8">
            <div className="row justify-content-between justify-content-lg-end ">
              <div
                className="col col-12 col-lg-4 mx-lg-3 py-4 py-lg-5 mb-lg-3"
                style={{ borderTop: "1px solid black" }}
              >
                <h2 className="fs-1 mb-4">17,500</h2>
                <p className="fs-3">Accidents Averted</p>
                <Link
                  to="#"
                  className="text-decoration-none fs-6 fw-bold text-dark"
                >
                  Know More{" "}
                  <i className={`fa-solid fa-arrow-up-right-from-square`}></i>
                </Link>
              </div>
              <div
                className="col col-12 col-lg-4 mx-lg-3 py-4 py-lg-5 mb-lg-3"
                style={{ borderTop: "1px solid black" }}
              >
                <h2 className="fs-1 mb-4">160.2 KMS</h2>
                <p className="fs-3">With no accidents on a Truck</p>
                <Link
                  to="#"
                  className="text-decoration-none fs-6 fw-bold text-dark"
                >
                  Read Story{" "}
                  <i className={`fa-solid fa-arrow-up-right-from-square`}></i>
                </Link>
              </div>
              <div
                className="col col-12 col-lg-4 mx-lg-3 py-4 py-lg-5 mb-lg-3"
                style={{ borderTop: "1px solid black" }}
              >
                <h2 className="fs-1 mb-4">12,000</h2>
                <p className="fs-3">Drivers Trained</p>
                <Link
                  to="#"
                  className="text-decoration-none fs-6 fw-bold text-dark"
                >
                  Know More{" "}
                  <i className={`fa-solid fa-arrow-up-right-from-square`}></i>
                </Link>
              </div>
              <div
                className="col col-12 col-lg-4 mx-lg-3 py-4 py-lg-5 mb-lg-3"
                style={{ borderTop: "1px solid black" }}
              >
                <h2 className="fs-1 mb-4">Millions</h2>
                <p className="fs-3">of tonnes of Co2 reduced</p>
                <Link
                  to="#"
                  className="text-decoration-none fs-6 fw-bold text-dark"
                >
                  Find out how{" "}
                  <i className={`fa-solid fa-arrow-up-right-from-square`}></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container about-features-section">
        <h2 className="fs-1 fw-bold mb-4">Salient Features</h2>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-5">
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">Unified Alert Platform</h4>
              <p className="fs-6">
                Receive alerts from various sources, such as vehicles, sensors,
                and systems, in a single dashboard.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">Customizable Alerts</h4>
              <p className="fs-6">
                Set up personalised alerts based on your specific needs and
                preferences.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">Real-time Notifications</h4>
              <p className="fs-6">
                Get instant alerts and notifications to ensure prompt action.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">Advanced Analytics</h4>
              <p className="fs-6">
                Gain insights into alert patterns and trends to optimise your
                operations.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">Integration</h4>
              <p className="fs-6">
                Seamlessly integrate with your existing systems and software.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">Data-Driven Decisions</h4>
              <p className="fs-6">
                Make informed decisions with our analytics and reporting tools.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">On-Demand Event Footage Access</h4>
              <p className="fs-6">
                Easily access and request video footage whenever a vehicle is in
                use.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">Don’t Sift Through Videos</h4>
              <p className="fs-6">
                Shoora’s On-Demand Event Footage Access organises the most
                relevant events for your review.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">Instant Access to Event Video</h4>
              <p className="fs-6">
                Receive immediate alerts and locate video evidence of driver
                distraction instantly.
              </p>
            </div>
          </div>
          <div className="col" style={{ padding: "1px" }}>
            <div className="p-3" style={{ height: "220px" }}>
              <h4 className="fw-bold">HD Videos for Clear Visibility</h4>
              <p className="fs-6">
                Get crystal-clear insights into vehicle surroundings with easily
                accessible HD dash cam footage.
              </p>
            </div>
          </div>
        </div>
      </div>

      <SafetySlider slides={slides} />

      <CardContainer
        heading="Life With Shoora"
        desc="Discover Shoora through the stories of our associates and the meaningful impact we create together."
      >
        <Card
          bgColor="#f4f4f4"
          type="primary"
          headingColor="#0d004a"
          heading="Truck Driver Safety Tips: A Guide to Protecting Lives on the Road"
          desc="Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives. Here are some essential truck driver safety tips."
          imgsrc="https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600"
          link="/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road"
          linkText="Read Article"
        />
        <Card
          bgColor="#eaca13"
          type="vibrant"
          heading="AIS-140’s Mandate for Telematics Devices"
          desc="Shoora is creating a better world through its decarbonisation initiatives and e-waste recycling. From driving civic engagement with youth to create effective awareness our associates are driving impact and change."
          imgsrc="https://www.easyembedded.net/images/ais2.jpg"
          link="/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles"
          linkText="Read Article"
        />
        <Card
          type="img"
          heading="Join Us"
          desc="If you’re looking for a rewarding career and the chance to shape the future, explore a career with Shoora."
          imgsrc="https://images.pexels.com/photos/6203795/pexels-photo-6203795.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          linkText="Find Jobs"
          link="/careers"
        />
      </CardContainer>

     

      {/* <div className="resources-section">
        <div className="container">
          <CardSlider />
        </div>
      </div> */}
    </Page>
  );
};

export default About;
